import Tab from '$tablet-app/src/app/components/Tab';
import { palette } from '$tablet-app/src/app/theme';
import { TaskListType } from '@akin-home/amplify';
import { ChecklistModel } from '@akin-home/checklists';
import { colors, spacing } from '@akin-home/theme';
import React, { FC, useMemo, useState } from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import ChecklistColumn from './ChecklistColumn';
import { ColumnDataType } from './types';

interface Props {
  checklists: ChecklistModel[];
  onPressNewChecklist?: (listType?: TaskListType) => void;
}

const COLUMN_DATA: ColumnDataType[] = [
  {
    type: TaskListType.Shopping,
    typeLabel: 'Shopping List',
    title: 'Shopping Lists',
    subtitle: 'What needs to be bought',
    titleColor: palette.Primary_blue,
    backgroundColor: colors.blue.shopping_list_background,
  },
  {
    type: TaskListType.ToDo,
    typeLabel: 'Todo List',
    title: 'To-do lists',
    subtitle: 'What has to be done',
    titleColor: palette.Bright_green,
    backgroundColor: colors.green.todo_list_background,
  },
  {
    type: TaskListType.Checklist,
    typeLabel: 'Checklist',
    title: 'Checklists',
    subtitle: 'What do you need to bring',
    titleColor: palette.Dark_pink,
    backgroundColor: colors.pink.background,
  },
];

const ChecklistsScreenViewBody: FC<Props> = (props) => {
  const { checklists, onPressNewChecklist } = props;

  /** Group the incoming lists for the columns */
  const lists = useMemo(() => {
    const lists = {} as { [x in TaskListType]: ChecklistModel[] };

    Object.values(TaskListType).forEach((type) => {
      lists[type] = checklists.filter((list) => list.type === type);
    });

    return lists;
  }, [checklists]);

  const onNewPress = (type?: TaskListType) => () => onPressNewChecklist?.(type);

  const { width } = useWindowDimensions();
  const isSmallScreen = width < 900;

  const [currentTab, setCurrentTab] = useState(0);
  if (isSmallScreen) {
    const data = COLUMN_DATA[currentTab];
    return (
      <View style={styles.portraitModeContainer}>
        <View style={styles.tabContainer}>
          {COLUMN_DATA.map((data, index) => (
            <Tab
              key={`${data.type}_${index}`}
              onPress={() => setCurrentTab(index)}
              active={index === currentTab}
            >
              {data.typeLabel}
            </Tab>
          ))}
        </View>

        <View style={styles.checklistContainer}>
          <ChecklistColumn
            key={`${data.type}_${currentTab}`}
            columnData={data}
            list={lists[data.type]}
            onNewPress={onNewPress(data.type)}
          />
        </View>
      </View>
    );
  } else {
    return (
      <>
        {COLUMN_DATA.map((data, index) => (
          <ChecklistColumn
            key={`${data.type}_${index}`}
            columnData={data}
            list={lists[data.type]}
            onNewPress={onNewPress(data.type)}
          />
        ))}
      </>
    );
  }
};

export default ChecklistsScreenViewBody;

const styles = StyleSheet.create({
  portraitModeContainer: {
    width: '100%',
    height: '100%',
    flex: 1,
    flexDirection: 'column',
    gap: spacing[3],
  },
  tabContainer: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  checklistContainer: {
    width: '100%',
    height: '100%',
    flex: 1,
    flexDirection: 'row',
  },
});
